/**
 * Runs before React mounts. `beforeinstallprompt` can fire before any component
 * attaches a listener, so we stash it on `window` and broadcast a DOM event.
 */
export function installPromptCaptureSetup() {
  if (typeof window === 'undefined') return;

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.__deferredInstallPrompt = e;
    window.dispatchEvent(new CustomEvent('appbeforeinstallprompt'));
  });
}
